import * as yup from "yup";

export const loginEmailSchema = yup.object({
  email: yup.string().email().required(),
});
